import React, { Component } from 'react';
import { Container, Accordion, Icon, Table, Modal, Input, Dimmer, Header, Button, Dropdown, Popup } from 'semantic-ui-react';
import { PtInput, PtSelect, PtDateInput, TextSelect, PtTextBox } from '../../../grit-utilities';
import DropdownLib from '../../../DropdownLib';
import 'semantic-ui-css/semantic.min.css';
import ScrollArea from 'react-scrollbar';
import '../../../index.css';
import config from '../../../config.json';
import $ from 'jquery';
import '../../../index.css';
import { LabelFactory, Menu, MenuItem, MenuDivider, Popover, Position, PopoverInteractionKind } from '@blueprintjs/core';

export default class NewPanel extends Component {
    constructor(props) {

        super(props);
        this.state = {
            ...this.props.pointModel,
            selectedIndex: 1,
            isPaste: false
        }
    }

    renderpanel() {
        const { materialOptions } = DropdownLib.getDropdowns().Signs_Panel;
        const { typeOptions } = DropdownLib.getSignNum().Signs_Types;
        const { typeOptions: typeOptionsDesc } = DropdownLib.getSignTypeDesc().Signs_Types;
        const { directionOptions } = DropdownLib.getDropdowns().Signs_Panel;

        const Barcodeitem = this.state.Panel.data.map((d) => {
            if (this.state.selectedIndex === d.key)
                return (
                    <PtInput key={d.key} inputType="number"
                        label="Bar Code" value={d.BarCode === null ? '' : d.BarCode}
                        onChange={this.onInputChange} name="BarCode" disabled={this.props.disabled} />
                )
        })

        const signMessage = this.state.Panel.data.map((d) => {
            if (this.state.selectedIndex === d.key)
                return (
                    <PtTextBox key={d.key} inputType="text" rows="1"
                        label="Message" value={d.SignMessage === null ? '' : d.SignMessage}
                        onChange={this.onInputChange} name="SignMessage" disabled={this.props.disabled} />
                )
        })

        const panelcodeNum = this.state.Panel.data.map((d, i) => {
            if (this.state.selectedIndex === d.key) {
                return (
                    <TextSelect
                        width={"100px"}
                        key={i} options={typeOptions} id="num"
                        label="Sign Type #"
                        onChange={this.onInputChange} name="PanelCode" disabled={this.props.disabled} />

                )
            }
        })

        const panelcodeDesc = this.state.Panel.data.map((d, i) => {
            if (this.state.selectedIndex === d.key) {
                return (
                    <TextSelect
                        width={"200px"}
                        key={i} options={typeOptionsDesc} id="desc"
                        label="Description"
                        onChange={this.onInputChange} name="PanelCode" disabled={this.props.disabled} />
                )
            }
        })

        const facingDirection = this.state.Panel.data.map((d, i) => {
            if (this.state.selectedIndex === d.key) {
                return (
                    <PtSelect key={i} options={directionOptions}
                        label="Facing Direction" defaultVal={d.FacingDirectionId === null ? 0 : d.FacingDirectionId}
                        onChange={this.onChangeDropdown} name="FacingDirectionId" disabled={this.props.disabled} />
                )
            }
        })

        const material = this.state.Panel.data.map((d, i) => {
            if (this.state.selectedIndex === d.key) {
                return (
                    <PtSelect key={i} options={materialOptions}
                        label="Material" defaultVal={d.Material === null ? 0 : d.Material}
                        onChange={this.onChangeDropdown} name="Material" disabled={this.props.disabled} />
                )
            }
        })

        const panelHeight = this.state.Panel.data.map((d, i) => {
            if (this.state.selectedIndex === d.key) {
                return (
                    <PtInput key={i} inputType="number"
                        label="Height (in.)" value={d.PanelHeight === null ? '' : d.PanelHeight}
                        onChange={this.onInputChange} name="PanelHeight" disabled={this.props.disabled} />
                )
            }
        })

        const panelWidth = this.state.Panel.data.map((d, i) => {
            if (this.state.selectedIndex === d.key) {
                return (
                    <PtInput key={i} inputType="number"
                        label="Width (in.)" value={d.PanelWidth === null ? '' : d.PanelWidth}
                        onChange={this.onInputChange} name="PanelWidth" disabled={this.props.disabled} />
                )
            }
        })

        const installedDate = this.state.Panel.data.map((d, i) => {
            if (this.state.selectedIndex === d.key) {
                return (
                    <PtDateInput label="Last Installed/ Replaced Date" value={d.InstalledDate ? d.InstalledDate.slice(0, 10) : null} disabled={this.props.disabled}
                        onChange={(date) => { this.onChangeDate(date, "InstalledDate"); }} name="InstalledDate" minDate={new Date(1900, 0, 1)} />
                )
            }
        })

        const expiredDate = this.state.Panel.data.map((d, i) => {

            if (this.state.selectedIndex === d.key) {
                return (
                    <PtDateInput label="Expire Date (Warranty)" value={d.ExpiredDate ? d.ExpiredDate.slice(0, 10) : null} disabled={this.props.disabled}
                        onChange={(date) => { this.onChangeDate(date, "ExpiredDate"); }} name="ExpiredDate" minDate={new Date(1900, 0, 1)} />
                )
            }
        })
        return (
            <Container>
                <ScrollArea
                    speed={1}
                    className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                    contentClassName="content"
                    smoothScrolling={true}>
                    <div style={{ width: 100, float: 'left' }}>

                        <PtSelect key={this.props.pointModel.Panel.data} name='availableActivity' options={this.props.pointModel.Panel.data}
                            defaultVal={this.state.selectedIndex}
                            onChange={this.onChangeIndex} />
                    </div>

                    <strong style={{ float: 'left', paddingTop: 10 }}>of {this.state.Panel.data.length}</strong>
                    <Button style={{ float: 'left', marginTop: 5, marginLeft: 6 }} size='tiny' color='blue' onClick={() => {
                        this.addNewRecord();
                    }}
                        disabled={this.props.disabled}
                    >New</Button>
                    <Button style={{ float: 'left', marginTop: 5, marginLeft: 5 }} size='tiny' color='red' onClick={() => {
                        this.deleteRecord(this.state.selectedIndex);
                    }}
                        disabled={this.props.disabled}
                    >Delete</Button>


                    {!this.state.isPaste && !this.props.disabled &&
                        <Popover interactionKind={PopoverInteractionKind.HOVER} style={{ width: '200 !important' }} content={
                            <Menu>
                                {/* <MenuDivider title="Options" />
                            <MenuDivider /> */}
                                <MenuItem key="attributes" text="Copy Panel" active onClick={() => { this.copyRecord(this.state.selectedIndex) }} />
                                <MenuItem key="attributes" text="Cut Panel" active onClick={() => { this.cutRecord(this.state.selectedIndex) }} />
                            </Menu>} position={Position.BOTTOM_LEFT}>
                            <Button style={{ float: 'left', marginTop: 5, marginLeft: 5 }} icon color='teal' size='tiny' disabled={this.props.disabled}>
                                <Icon name='copy' />
                            </Button>
                        </Popover>
                    }
                    {this.state.isPaste && !this.props.disabled &&
                        <Popup
                            trigger={<Button style={{ float: 'left', marginTop: 5, marginLeft: 5 }} icon color='green' size='tiny' onClick={() => {
                                this.pasteRecord(this.state.selectedIndex);
                            }} disabled={this.props.disabled}>
                                <Icon name='paste' />
                            </Button>}
                            content='Paste Panel'
                            on={['hover', 'click']}
                        />}

                    <Table compact="very" style={{ 'border': 'None', marginBottom: 0 }}>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell >{panelcodeNum}</Table.Cell>
                                <Table.Cell > {panelcodeDesc}</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>

                    <div>{signMessage}</div>
                    <div>{installedDate}</div>
                    <div>{facingDirection}</div>
                    <div>{material}</div>
                    <div style={{ 'width': '50%' }}>{panelHeight}</div>
                    <div style={{ 'width': '50%', 'float': 'right', 'marginTop': '-21%' }}>{panelWidth}</div>
                    <div>{Barcodeitem}</div>
                    <div>{expiredDate}</div>

                </ScrollArea>
            </Container>
        )
    }

    isPaste() {
        let paste = false;
        var jsn = JSON.parse(sessionStorage.getItem('copiedPanel'));
        let value = this.state;
        if (jsn && value.point.id && value.point.id != jsn.pointId) {
            const storedTime = new Date(jsn.time);
            const currentTime = new Date();
            const timeDifference = (currentTime - storedTime) / 60000;
            (timeDifference <= 2) &&
                (paste = true);
        }
        this.setState({ isPaste: paste });
    }

    copyRecord(index) {
        let value = this.state;
        sessionStorage.setItem('copiedPanel', JSON.stringify({ pointId: value.point.id, panelType: index, isCut: false, time: new Date() }));
    }

    cutRecord(index) {
        let value = this.state;
        sessionStorage.setItem('copiedPanel', JSON.stringify({ pointId: value.point.id, panelType: index, isCut: true, time: new Date() }));
    }

    pasteRecord(index) {
        var jsn = JSON.parse(sessionStorage.getItem('copiedPanel'))
        if (jsn) {
            const storedTime = new Date(jsn.time);
            const currentTime = new Date();
            const timeDifference = (currentTime - storedTime) / 60000;
            if (timeDifference <= 2) {
                this.props.showSpinner(true)
                let finalData = {
                    pointId: jsn.pointId,
                    pastePointId: this.state.point.id,
                    isCut: jsn.isCut ? 1 : 0,
                    panelType: jsn.panelType
                };
                console.log('Final Data ', finalData)

                $.ajax({
                    type: 'POST',
                    url: `${config.server}\\pastepanel`,
                    contentType: 'application/json',
                    data: JSON.stringify(finalData),

                    success: (data) => {
                        if (data && data.Condition && data.Panel) {
                            this.props.pointModel.Panel.data = data.Panel.data;
                            this.props.pointModel.Condition.conditionData = data.Condition.conditionData;
                            const tempArray = this.props.pointModel
                            this.setState({ [this.props.pointModel]: tempArray })

                            sessionStorage.removeItem('copiedPanel');
                            this.setState({ isPaste: false });
                        }
                        this.props.showSpinner(false)
                    },
                    error: (error) => {
                        this.props.showSpinner(false)
                        alert('Error: Failed to paste panels')
                        console.log(error)
                    }
                });

            } else {
                sessionStorage.removeItem('copiedPanel');
                this.setState({ isPaste: false });
                alert('Please copy/ cut again and paste within 2 minutes!')
            }
        }
    }

    deleteRecord(index) {
        if (index === 1) {
            alert('Deleting Primary Panel is not Allowed. Please delete the point')
        }
        else if (this.props.pointModel.Panel.data[index - 1].key === this.props.pointModel.Panel.data[this.props.pointModel.Panel.data.length - 1].key) {
            this.props.triggerNeedSave()
            this.props.pointModel.Panel.data = this.props.pointModel.Panel.data.filter(panel => {
                return panel.key !== index
            })
            this.props.pointModel.Condition.conditionData = this.props.pointModel.Condition.conditionData.filter(panel => {
                return panel.key !== index
            })
            const tempArray = this.props.pointModel
            console.log(tempArray)
            this.setState({ [this.props.pointModel]: tempArray, selectedIndex: 1 }, () => { this.onSearchActive() })
        }
        else {
            this.props.triggerNeedSave()
            this.props.pointModel.Panel.data = this.props.pointModel.Panel.data.filter(panel => {
                return panel.key !== index
            })

            this.props.pointModel.Panel.data.map((panel, i) => {
                if (panel.key !== i + 1) {
                    panel.key = panel.key - 1
                    panel.value = panel.value - 1
                    panel.label = 'Sign-' + panel.key
                    panel.PanelType = panel.key
                }
            })
            this.props.pointModel.Condition.conditionData = this.props.pointModel.Condition.conditionData.filter(panel => {
                return panel.key !== index
            })

            this.props.pointModel.Condition.conditionData.map((panel, i) => {
                if (panel.key !== i + 1) {
                    panel.key = panel.key - 1
                    panel.value = panel.value - 1
                    panel.label = 'Sign-' + panel.key
                    panel.PanelType = panel.key
                }
            })
            const tempArray = this.props.pointModel
            console.log(tempArray)
            this.setState({ [this.props.pointModel]: tempArray, selectedIndex: 1 }, () => { this.onSearchActive() })
        }
    }


    render() {
        return (this.renderpanel())
    }

    addNewRecord() {
        this.props.triggerNeedSave()
        let label
        let Paneltype
        let panelkey
        let panelvalue
        if (this.props.pointModel.Panel.data.length === 0) {
            label = 'Primary'
            Paneltype = 1
            panelkey = 1
            panelvalue = 1
        }
        else {
            label = 'Sign-' + (parseInt(this.props.pointModel.Panel.data.length) + 1)
            Paneltype = this.props.pointModel.Panel.data[this.props.pointModel.Panel.data.length - 1].key + 1
            panelkey = this.props.pointModel.Panel.data[this.props.pointModel.Panel.data.length - 1].key + 1
            panelvalue = this.props.pointModel.Panel.data[this.props.pointModel.Panel.data.length - 1].key + 1
        }
        if (this.props.pointModel.Panel.data.length > 4)
            alert('More than 5 panels not allowed')
        else
            this.props.pointModel.Panel.data.push(
                {
                    key: panelkey,
                    value: panelvalue,
                    label: label,
                    BarCode: null,
                    PanelCode: null,
                    FacingDirectionId: null,
                    Material: null,
                    PanelHeight: null,
                    PanelWidth: null,
                    InstalledDate: null,
                    ExpiredDate: null,
                    PanelType: Paneltype,
                    SignMessage: null
                })
        this.props.pointModel.Condition.conditionData.push(
            {
                PanelType: Paneltype,
                PriorityComments: null,
                PriorityCondition: false,
                PriorityDate: null,
                PriorityHigh: false,
                PriorityKnockdown: false,
                PriorityMissing: false,
                PriorityOther: false,
                RetroInspectionDate: null,
                RetroRefBkg2: null,
                RetroRefBkg5: null,
                RetroRefLegend2: null,
                RetroRefLegend5: null,
                ViPCComment: null,
                ViPCFade: false,
                ViPCGraffiti: false,
                ViPCObstructed: false,
                ViPCOther: false,
                ViPCPositionHeight: false,
                ViPCSeverity: null,
                ViRefComment: null,
                ViReflectSeverity: null,
                ViSCBreakaway: false,
                ViSCComment: null,
                ViSCCorrosion: false,
                ViSCOther: false,
                ViSCSeverity: null,
                ViSCStruct: false,
                VisualInspectDate: null,
                key: panelkey,
                label: label,
                value: panelvalue
            })
        const tempArray = this.props.pointModel;
        this.setState({ [this.props.pointModel]: tempArray, selectedIndex: parseInt([this.props.pointModel.Panel.data.length]) }, () => { this.onSearchActive() })

    }
    onChangeIndex = (e) => {
        const { target } = e;
        const { value } = target;
        this.state.Panel.data.map((panel) => {
            if (panel.key === parseInt(value))
                this.setState({ selectedIndex: parseInt(value) }, () => { this.onSearchActive() })
        })
    }

    componentDidMount = () => {
        this.isPaste();
        this.onSearchActive()
    }

    onChangeDropdown = (e) => {
        const { target } = e;
        const { name, value } = target;
        this.props.triggerNeedSave();
        this.state.Panel.data.map((panel, i) => {
            if (this.state.selectedIndex === panel.key) {
                panel[name] = parseInt(value)
                this.props.pointModel.Panel.data[i][name] = parseInt(value)
            }
        })
    }

    onSearchActive = () => {
        this.state.Panel.data.map((d, i) => {
            if (this.state.selectedIndex === d.key) {
                this.setupPanelCode(d.PanelCode)
            }
        })

    }

    setupPanelCode = (val) => {
        if (val === null)
            return
        var inputs = document.getElementsByClassName("CodeInput")
        var types = DropdownLib.getSignNum().Signs_Types;
        var desc = DropdownLib.getSignTypeDesc().Signs_Types;
        for (var x = 0; x < types.typeOptions.length; x++) {
            if (types.typeOptions[x].value === parseInt(val)) {
                inputs[0].value = types.typeOptions[x].label
            }
        }
        for (var x = 0; x < desc.typeOptions.length; x++) {
            if (desc.typeOptions[x].value === parseInt(val)) {
                inputs[1].value = desc.typeOptions[x].label
            }
        }

    }

    onInputChange = (e) => {
        const { target } = e
        const { name, value } = target
        this.props.triggerNeedSave()
        this.state.Panel.data.map((panel, i) => {
            if (this.state.selectedIndex === panel.key) {
                if (name === 'PanelWidth' || name === 'PanelHeight') {
                    panel[name] = parseFloat(value)
                    this.props.pointModel.Panel.data[i][name] = parseFloat(value)
                }
                else if (name === 'PanelCode') {
                    var input = e.target,
                        list = input.getAttribute('list'),
                        options = document.querySelectorAll('#' + list + ' option[value="' + input.value + '"]'),
                        hiddenInput = document.getElementById('PanelCode-hidden'),
                        inputVal = input.value

                    hiddenInput.value = inputVal
                    for (var i = 0; i < options.length; i++) {
                        var option = options[i];
                        if (option.value === inputVal) {
                            hiddenInput.value = option.getAttribute('data-value');
                            this.setupPanelCode(hiddenInput.value)
                            this.state.Panel.data.map((d, i) => {
                                if (this.state.selectedIndex === d.key) {
                                    panel[name] = parseInt(hiddenInput.value)
                                    this.props.pointModel.Panel.data[i][name] = parseInt(hiddenInput.value)
                                }
                            })

                            break;
                        }
                    }

                }
                else {
                    panel[name] = value
                    this.props.pointModel.Panel.data[i][name] = value
                }
            }
        })
        console.log(this.state)

    }

    onChangeDate = (date, name) => {
        this.props.triggerNeedSave();
        if (date instanceof Date && !isNaN(date)) {
            this.state.Panel.data.map((panel, i) => {
                if (this.state.selectedIndex === panel.key) {
                    panel[name] = date ? `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}` : null;
                    this.props.pointModel.Panel.data[i][name] = date ? `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}` : null;
                }
            });
        }
    }


}


// WEBPACK FOOTER //
// ./src/layers/tabs/sign/panel.js